import Cookies from 'js-cookie';

export function object2String(obj){
  if(Object.prototype.toString.call(obj) === '[object Array]' || Object.prototype.toString.call(obj) === '[object Object]'){
    return JSON.stringify(obj)
  }else{
    return obj;
  }
}

export function errorToLogin(){
  let _href = encodeURIComponent(location.href);
  window.location.href = `/login?return_url=${_href}`;
}

export function returnUrl(){
  let _search = new URLSearchParams(location.search);
  let _return_url = _search.get('return_url');
  _return_url = decodeURIComponent(_return_url);
  window.location.href = _return_url;
}

export async function sleepFun(v){
  return await new Promise(resolve => {
    setTimeout(() => {
      resolve(true);
    },v)
  })
}

export function setCookie(name, value){
  let hostname = window.location.hostname;

  if(window.location.hostname.indexOf('smartz.cloud') > -1){
    hostname = 'smartz.cloud'
  }

  let expires = 180;

  Cookies.set(name, value, {domain: hostname, secure: true, path: '/', expires: expires})
}

export function getCookie(name){
  return Cookies.get(name);
}
window['getCookie'] = getCookie;

export function removeCookie(name){
  let hostname = window.location.hostname;

  if(window.location.hostname.indexOf('smartz.cloud') > -1){
    hostname = 'smartz.cloud'
  }

  Cookies.remove(name, {domain: hostname, secure: true, path: '/'});
}
window['removeCookie'] = removeCookie;

export function getBrowserInfo() {
  const ua = window.navigator.userAgent;
  let name, version;

  // 按优先级匹配浏览器标识
  if (ua.includes("Edg")) { // Edge (Chromium)
    name = "Microsoft Edge";
    version = ua.match(/Edg\/([\d.]+)/)[1];
  } else if (ua.includes("Chrome")) { // Chrome/Chromium
    name = "Chrome";
    version = ua.match(/Chrome\/([\d.]+)/)[1];
  } else if (ua.includes("Firefox")) { // Firefox
    name = "Firefox";
    version = ua.match(/Firefox\/([\d.]+)/)[1];
  } else if (ua.includes("Safari")) { // Safari
    name = "Safari";
    const safariVersionMatch = ua.match(/Version\/([\d.]+)/);
    version = safariVersionMatch ? safariVersionMatch[1] : "unknown version";
  } else { // 其他浏览器
    name = "Unknown browser";
    version = "unknown version";
  }

  return { name, version, ua };
}



// WEBPACK FOOTER //
// ./src/utils/common/index.js